import { Injectable } from "@angular/core";

export interface RedistributionPersistedState {
  interfaceSearchValue: string | null;
  caseIdValue: string;
  claimIdValue: string;
  selectedRouteId: string;
  selectedRouteLabel: string;
  messageType: string;
  deploymentKey: string;
  pipelineselectclass: string;
  /** From api/Routes/get — sent on POST body as sourceAgentId (not shown in UI). */
  sourceAgentId: string;
}

@Injectable({ providedIn: "root" })
export class RedistributionStateService {
  private state: RedistributionPersistedState | null = null;

  getState(): RedistributionPersistedState | null {
    return this.state;
  }

  saveState(s: RedistributionPersistedState): void {
    this.state = s;
  }

  clearState(): void {
    this.state = null;
  }
}
 